// const { htmlPrefilter, contains } = require('jquery');
// const { default: Axios } = require('axios');

// require('../_js/bootstrap');
// require('../_js/utils');

$("#NFeItens").on("click", ".btnVolume", function (ev) {
    ev.preventDefault();
    $("#erroVolume").hide();

    if (window.edi) {
        $("#clearVolume").hide();
        $("#importVolume").hide();
    } else {
        $("#clearVolume").show();
        $("#importVolume").show();
    }

    //var data = table.row( $(this).parents('tr') ).data();
    let data = $("#NFeItens").DataTable().row($(this).parents("tr")).data();
    $("#nfe").val(window.nfe);
    //$("#nfe_quantidade").html(data.quantidade);

    //$("#nfe_item_desc").html(data.descricao);
    $("#nfe_item_desc").val(data.descricao);
    $("#nfe_quantidade").val(data.quantidade);
    $("#nfe_oc_numero").val(data.ordem_compra);
    $("#nfe_oc_item").val(data.ordem_compra_item);
    $("#nfe_item_obs").val(data.obs);
    //adicionar item BR e cor
    $("#volItembr").val(data.item_br);
    $("#volLargura").val(data.largura); //ADICIONADO O CAMPO LARGURA - OPCIONAL
    $("#volCor").val(data.cor);
    $("#nfe_unidade").val(data.unidade);

    $("#nfe_item").val(data.item);

    $("#nfe_item_id").val(data.id);

    // Primeiro verifica a condição do ESP1
    if (
        window.emitente_id === 17 &&
        data.descricao.toUpperCase().includes("ESPECIAL")
    ) {
        $("#volTamanho").val("ESP1");
    } else {
        // Se não for ESP1, então verifica se tem Tx
        const tamMatch = data.descricao.match(/\bT([1-9])\b/);
        if (window.emitente_id === 17 && tamMatch) {
            $("#volTamanho").val(tamMatch[1]); // Pega apenas o número
        } else {
            $("#volTamanho").val("0"); // Valor padrão caso nenhuma condição seja atendida
        }
    }

    $("#listaVolume").DataTable({
        language: {
            url: "/pt-br.json",
        },
        ajax: "/listVolume/" + $("#nfe_item_id").val(),
        scrollY: "150px",
        scrollCollapse: true,
        searching: false,
        destroy: true,
        paging: false,
        responsive: true,
        lengthChange: false,
        autoWidth: false,
        info: false,
        createdRow: function (row, data, dataIndex) {
            //console.log(data.quantidade);
            //console.log( window.totalVolumeModal);

            // Total dos volumes do Item no Modal
            window.totalVolumeModal =
                window.totalVolumeModal + parseFloat(data.quantidade);
        },
        columns: [
            { data: "volume" },
            { data: "item_br" },
            { data: "quantidade" },
            { data: "cor" },
            { data: "largura", defaultContent: "-" },
            { data: "tamanho" },
            { data: "epc" },
            {
                data: null,
                className: "text-center",
                //"defaultContent": '<button class="btn btn-sm btn-danger text-center delVolume"><i class="far fa-trash-alt"></i></button>'
                render: function (data, type, row, meta) {
                    if (type === "display") {
                        if (!window.edi) {
                            return '<button class="btn btn-sm btn-danger text-center delVolume"><i class="far fa-trash-alt"></i></button>';
                        } else {
                            let btnEditar =
                                '<button class="btn btn-sm btn-primary text-center mr-1 btnEditarVolume" title="Editar"><i class="fas fa-edit"></i></button>';
                            let btnImprimir =
                                '<button class="btn btn-sm btn-secondary text-center printVolume" title="Reimpressão de Volume"><i class="fa fa-print"></i></button>';
                            return btnEditar + btnImprimir;    
                        }
                    }
                },
                defaultContent: "",
            },
        ],
        footerCallback: function (row, data, start, end, display) {
            var api = this.api(),
                data;
            var intVal = function (i) {
                return typeof i === "string"
                    ? i.replace(/[\$,]/g, "") * 1
                    : typeof i === "number"
                    ? i
                    : 0;
            };
            pageTotal = api
                .column(2, { page: "current" })
                .data()
                .reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                }, 0);

            // Update footer
            //$( api.column( 2 ).footer() ).html('Total: '+pageTotal.toFixed(4));
            $(api.column(2).footer()).html(pageTotal.toFixed(4));
            //$( api.column( 1 ).footer() ).html('<span class="text-right">Total:</span>');
        },
    });

    //$("#addListaVolume").find("input").val('');
    $("#modal_volume").modal({
        backdrop: "static",
        keyboard: false,
        handleUpdate: true,
        show: true,
    });
});

$("#NFeItens").on("click", ".btnDelItemNFe", function (ev) {
    ev.preventDefault();
    let data = $("#NFeItens").DataTable().row($(this).parents("tr")).data();
    let nfeItemId = data.id;

    //$("#modal_delNFe").modal();

    $.post("/deleteItemNFe", { id: nfeItemId }, function (data) {
        location.reload();
        // $("#modal_delNFe").modal('hide');
    });
    //$("#del_numero_nfe").html(data.numero);
});

$("#listaVolume").on("click", ".delVolume", function (ev) {
    ev.preventDefault();
    let volume = $("#listaVolume")
        .DataTable()
        .row($(this).parents("tr"))
        .data();
    $(this).attr("disabled", false);
    $.post(
        "/delVolume/",
        { id: volume.id, nfe_item_id: $("#nfe_item_id").val() },
        function (data) {
            //console.log(data);
            $("#listaVolume").DataTable().ajax.reload();
        }
    );
});

$("#listaVolume").on("click", ".printVolume", function (ev) {
    ev.preventDefault();
    let volume = $("#listaVolume")
        .DataTable()
        .row($(this).parents("tr"))
        .data();
    $.get(`/printVolume/${volume.id}`, function (data) {
        // console.log(data);
        //$("#listaVolume").DataTable().ajax.reload();
        let zpl = data;

        try {
            socket.send(zpl);
            //alert('Etiquetas enviadas para impressora \n Arquivo EDI enviado para destinatário');
            $("#modalInfo")
                .modal()
                .find("p")
                .html("Etiqueta enviada para reimpressão!");
            setTimeout(() => {
                //location.reload();
                $("#modalInfo").modal("hide");
            }, 3000);
        } catch (e) {
            console.error("Socket não conectado");
            //alert('Problema ao conectar a impressora. \n Impressão cancelada! \n Visualizando etiqueta.');
            $.ajax({
                type: "POST",
                url: "/viewLabel",
                data: { zpl },
                success: function (data) {
                    //console.log(data);
                    window.open(data);
                },
            }).fail(function (error) {
                alert("Erro ao processar! 103");
                console.error(error);
            });
        }
    });
});

// Máscara
/* $("#volQuantidade").on('blur change input', function() {
    $(this).val(function(i, input) {
      input = input.replace(/\D/g, '');
      return (input / 100).toFixed(2);
    });
}).trigger('blur'); */

$("#addVolume").on("click", function (ev) {
    ev.preventDefault();
    let data = {
        nfe_id: window.nfe_id,
        nfe_item_id: $("#nfe_item_id").val(),
        item_br: $("#volItembr").val(),
        quantidade: $("#volQuantidade").val().replace(/,/g, "."),
        lote: $("#volLote").val(),
        tamanho: $("#volTamanho").val(),
        largura: $("#volLargura").val(),
        cor: $("#volCor").val(),
        validade: $("#volValidade").val(),
        unidade: $("#nfe_unidade").val(),
        multi: parseInt($("#multiplicador").val()),
    };

    if (data.quantidade <= 0) {
        $("#volQuantidade").css("border", "1px solid red");
        return;
    }

    if (data.item_br === "") {
        $("#volItembr").css("border", "1px solid red");
        return;
    }

    let volume_quantidade = parseFloat(
        $("#volQuantidade").val().replace(/,/g, ".")
    );

    if (isNaN(volume_quantidade)) {
        //alert('Quantidade inválida');
        $("#modalInfo").modal().find("p").html("Quantidade inválida");
        return;
    }

    $.ajax({
        type: "POST",
        url: "/addVolume",
        data,
        success: function (resp) {
            $("#listaVolume").DataTable().ajax.reload();
            setTimeout(() => {
                var $scrollBody = $(
                    $("#listaVolume").DataTable().table().node()
                ).parent();
                $scrollBody.scrollTop($scrollBody.get(0).scrollHeight);
            }, 900);

            $("#volQuantidade").css("border", "1px solid #ced4da");
            $("#volItembr").css("border", "1px solid #ced4da");
            //$("#addListaVolume").find("input").val('');
        },
        error: function (error) {
            console.log(error);
            if (error.status == 422) {
                $("#volQuantidade").css("border", "1px solid red");
                //responseText
                //alert(JSON.parse(error.responseText).message);
                let message = JSON.parse(error.responseText).message;
                console.log(message);
                //$(".modal-backdrop").remove();
                $("#modalInfo").modal().find("p").html(message);

                setTimeout(() => {
                    $("#modalInfo").modal("hide");
                }, 10000);
            }
        },
    });
});

$("#clearVolume").click(() => {
    //alertModal modal-content
    $("#modalLimpaVolume").modal();

    /* let confirma = confirm('Limpar lista de volumes?');

    if(!confirma) {
        return;
    }
    */
    $("#modalLimpaVolume .btn-danger").on("click", function (ev) {
        ev.preventDefault();
        //console.log($(this));

        $.post(
            "/clearVolumes",
            {
                nfe_id: window.nfe_id,
                nfe_item_id: parseInt($("#nfe_item_id").val()),
            },
            function (resp) {
                //console.log(resp);
                $("#listaVolume").DataTable().ajax.reload();
            }
        );

        $("#modalLimpaVolume").modal("hide");
    });
});

// Importar Volume
$("#importVolume").click(() => {
    //$(this).prop('disabled', true);
    console.log("Processando...");
    $("#fileVolume").trigger("click");
});

$("#fileVolume").on("change", function (ev) {
    //$('#formImport').submit();
    let file = ev.target.files;
    //console.log(file[0]);
    let xlsx = new ExcelToJSON();
    xlsx.parseExcel(file[0]);
    document.getElementById("formImport").reset();
});

var ExcelToJSON = function () {
    $("#_load").removeClass("d-none");
    this.parseExcel = function (file) {
        var reader = new FileReader();
        reader.onload = function (e) {
            var data = e.target.result;
            try {
                var workbook = XLSX.read(data, {
                    type: "binary",
                });
            } catch (e) {
                console.log(e);
                $("#_load").addClass("d-none");
                $("#modalInfo")
                    .modal()
                    .find("p")
                    .html("Arquivo selecionado não é válido!");
            }

            workbook.SheetNames.forEach(function (sheetName) {
                // Here is your object
                //console.log(sheetName);
                let dataVolume = [];
                let volumes = XLSX.utils.sheet_to_row_object_array(
                    workbook.Sheets[sheetName]
                );
                volumes = JSON.parse(
                    JSON.stringify(volumes).replace(/"\s+|\s+"/g, '"')
                );
                //console.log(volumes);
                let vol = [];
                //var json_object = JSON.stringify(XL_row_object);

                volumes.map((volume) => {
                    //Verifica se o ITEM DA NOTA é o que está sendo importado
                    //console.log(volume);

                    if (
                        parseInt(volume.NFITEM) ==
                            parseInt($("#nfe_item").val()) &&
                        parseInt(volume.NOTA) == parseInt($("#nfe").val())
                    ) {
                        if (window.emitente_id == 999999) {
                            try {
                                dataVolume.push({
                                    nfe_id: window.nfe_id,
                                    nfe_item_id: $("#nfe_item_id").val(),
                                    nota: volume.NOTA,
                                    item_br: volume.ITEM,
                                    quantidade: parseFloat(
                                        volume.QUANT.replace(/,/g, ".")
                                    ).toFixed(4),
                                    lote: volume.LOTE,
                                    tamanho: volume.TAMANHO,
                                    largura: parseFloat(volume.LARG).toFixed(2),
                                    cor: volume.COR,
                                    validade: volume.VALIDADE,
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        } else {
                            dataVolume.push({
                                nfe_id: window.nfe_id,
                                nfe_item_id: $("#nfe_item_id").val(),
                                nota: volume.NOTA,
                                item_br: volume.ITEM,
                                quantidade: volume.QUANT,
                                lote: volume.LOTE,
                                tamanho: volume.TAMANHO,
                                largura: parseFloat(volume.LARG).toFixed(2),
                                cor: volume.COR,
                                validade: volume.VALIDADE,
                            });
                        }
                    }
                });
                //console.log(dataVolume);

                $.post(
                    "/importVolume",
                    {
                        nfe_id: window.nfe_id,
                        nfe_item_id: $("#nfe_item_id").val(),
                        data: JSON.stringify(dataVolume),
                    },
                    function (resp) {
                        $("#_load").addClass("d-none");
                        //alert(resp.message);
                        let message = resp.message;
                        $("#modalInfo").modal().find("p").html(message);
                        setTimeout(() => {
                            $("#modalInfo").modal("hide");
                        }, 10000);

                        $("#listaVolume").DataTable().ajax.reload();
                        setTimeout(() => {
                            var $scrollBody = $(
                                $("#listaVolume").DataTable().table().node()
                            ).parent();
                            $scrollBody.scrollTop(
                                $scrollBody.get(0).scrollHeight
                            );
                        }, 900);

                        //console.log('Finalizado...');
                    }
                ).fail((err) => {
                    $("#listaVolume").DataTable().ajax.reload();

                    let message = JSON.parse(err.responseText).message;
                    $("#modalInfo").modal().find("p").html(message);
                    setTimeout(() => {
                        $("#modalInfo").modal("hide");
                    }, 10000);
                    //alert(JSON.parse(err.responseText).message);
                });
            });
        };

        reader.onerror = function (ex) {
            console.log(ex);
        };

        reader.readAsBinaryString(file);
    };
};

$("#formImport").submit(function (event) {
    /*  $.ajax({
         url: '/loadVolume',
         type: 'POST',
         data: new FormData(this),
         dataType: 'JSON',
         cache: false,
         contentType: false,
         processData: false,
         success: function(resp) {
             console.log(resp);
         },
         error: function(error) {
             if(error.status == 400) {
                 //console.log();
                 $("#errorNFe").removeClass('d-none');
                 $("#errorNFe").text(JSON.parse(error.responseText).message)

             }
         }
     }); */
});

$("#xmlFile").on("change", function () {
    $("#xmlForm").submit();
});

$("#xmlForm").submit(function (event) {
    event.preventDefault();

    $.ajax({
        url: "/loadXML",
        type: "POST",
        data: new FormData(this),
        dataType: "JSON",
        cache: false,
        contentType: false,
        processData: false,
        success: function (resp) {
            $("#errorNFe").addClass("d-none");
            window.location = "/listaNFeItens/" + resp.data.id;
        },
        error: function (error) {
            if (error.status == 400) {
                //console.log();
                $("#errorNFe").removeClass("d-none");
                $("#errorNFe").text(JSON.parse(error.responseText).message);
            }
        },
    });
});

function loadItens(nfeId) {
    //btnConfirmarNFe

    $.get(`/loadNFe/${nfeId}`, function (data) {
        itens = data.itens;
        //console.log(data.emitente);

        $("#nfe_numero").html("NFe: " + data.numero);
        window.nfe = data.numero;
        window.edi = data.edi;

        let juntar_itens = true;

        if (data.edi) {
            //alert();
            $("#btnConfirmarNFe").html("Reenviar EDI");

            $("#btnConfirmarNFe").removeClass("btn-warning");
            $("#btnConfirmarNFe").addClass("btn btn-secondary");
            $("#importVolume").attr("disabled", true);
            $("#nfe_item_desc").attr("disabled", true);
            $("#nfe_oc_numero").attr("disabled", true);
            $("#nfe_oc_item").attr("disabled", true);
            $("#editDescricao").hide();
        }

        if (data.emitente.juntar_itens == 0 || data.edi) {
            $("#nfe_quantidade").attr("disabled", true);
            $("#editQuantidade").hide();
            juntar_itens = false;
        }

        let totalVolumesNfe = 0;
        let totalItemNfe = 0;

        $("#NFeItens").DataTable().destroy();
        $("#NFeItens").DataTable({
            language: {
                url: "/pt-br.json",
            },
            //data: data.itens,
            data: itens,
            destroy: true,
            searching: false,
            paging: false,
            responsive: true,
            lengthChange: false,
            createdRow: function (row, data, dataIndex) {
                let totalVolumeItem = 0;
                data.volumes.map((item) => {
                    totalVolumeItem =
                        totalVolumeItem + parseFloat(item.quantidade);
                });
                //console.log(parseFloat(data.quantidade).toFixed(4));
                //console.log(totalVolumeItem.toFixed(4));

                //if(parseFloat(data.quantidade) == totalVolumeItem) {
                if (
                    parseFloat(data.quantidade).toFixed(4) ==
                    totalVolumeItem.toFixed(4)
                ) {
                    $(row).addClass("table-success");
                }
                totalVolumesNfe = totalVolumesNfe + totalVolumeItem;
                //console.log(parseFloat(totalVolumesNfe.toFixed(4)));

                totalItemNfe = totalItemNfe + parseFloat(data.quantidade);
            },
            columnDefs: [
                {
                    width: "100px",
                    targets: 0,
                },
            ],
            columns: [
                { defaultContent: window.nfe },
                { data: "item" },
                { data: "descricao" },
                {
                    data: "quantidade",
                    className: "text-center",
                },
                {
                    data: "unidade",
                    className: "text-center",
                },
                {
                    data: null,
                    className: "text-center",
                    render: function (data, type, row, meta) {
                        if (type === "display") {
                            let botao =
                                '<button title="Volumes" data-item="' +
                                data.item.id +
                                '" alt="Volumes" type="button" class="btnVolume btn btn-info btn-sm" style="color:#fff"><i class="fas fa-clipboard-list"></i></button>';
                            if (juntar_itens) {
                                botao +=
                                    '<button type="button" class="btnDelItemNFe btn btn-danger btn-sm ml-2" style="color:#fff"><i class="far fa-trash-alt"></i></button></div>';
                            }
                            return botao;
                        }
                    },
                    defaultContent: "",
                },
            ],
            footerCallback: function (row, data, start, end, display) {
                var api = this.api(),
                    data;
                var intVal = function (i) {
                    return typeof i === "string"
                        ? i.replace(/[\$,]/g, "") * 1
                        : typeof i === "number"
                        ? i
                        : 0;
                };
                pageTotal = api
                    .column(3, { page: "current" })
                    .data()
                    .reduce(function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0);

                // Update footer
                //$( api.column( 2 ).footer() ).html('Total: '+pageTotal.toFixed(4));
                $(api.column(3).footer()).html(pageTotal.toFixed(4));
                //$( api.column( 1 ).footer() ).html('<span class="text-right">Total:</span>');
            },
        });

        window.totalItemNfe = totalItemNfe.toFixed(4);
        window.totalVolumesNfe = totalVolumesNfe.toFixed(4);
    });
}

function load_nfe() {
    let button =
        '<div class="text-center"><button title="NFe Itens" alt="NFe Itens" type="button" class="loadNFe btn btn-secondary btn-sm" style="color:#fff"><i class="fab fa-buffer"></i></button>';
    button +=
        '<button type="button" class="delNFe btn btn-danger btn-sm ml-2" style="color:#fff"><i class="far fa-trash-alt"></i></button></div>';

    // Listagem de NFe
    $("#listaNFe").DataTable({
        language: {
            url: "/pt-br.json",
        },
        order: [[2, "desc"]],
        ajax: "/listaNFe",
        //searching: false,
        destroy: true,
        paging: true,
        responsive: true,
        autoWidth: false,
        // pageLength: 10,
        //info: false,
        columnDefs: [
            {
                targets: 3,
                render: function (data) {
                    return moment(data).format("DD/MM/YYYY HH:mm:ss");
                },
            },
        ],
        columns: [
            { data: "numero" },
            { data: "razao_social" },
            {
                data: "emissao",
                visible: false,
                searchable: false,
            },
            { data: "emissao" },
            {
                data: null,
                className: "text-center",
                render: function (data, type, row, meta) {
                    if (type === "display") {
                        if (data.edi == 0) {
                            // 'A enviar'
                            return '<div class="text-center"><span class="badge badge-warning">A Enviar</label></div>';
                        } else {
                            // 'Enviado'
                            return '<div class="text-center"><span class="badge badge-success">Enviado</label></div>';
                        }
                    }
                },
                defaultContent: "",
            },
            {
                data: null,
                className: "text-center",
                render: function (data, type, row, meta) {
                    if (type === "display") {
                        let itens = data.itens.filter((item) => {
                            return item.ignore_cfop === 0;
                        });
                        return itens.length;
                    }
                },
                defaultContent: "",
            },
            /*  {
                 "data": null,
                 defaultContent: (data.edi) ? button : buttonDisabled
             } */
            {
                data: null,
                className: "text-center",
                render: function (data, type, row, meta) {
                    if (type === "display") {
                        return button;
                    }
                },
                defaultContent: "",
            },
        ],
    });
}

// on close modal clear value in data attr
$("#modal_delNFe").on("hidden.bs.modal", function (e) {
    //console.log(e);
    $("#del_nfeId").data("nfeId", null);
});

$(".btn-info").on("click", function (ev) {
    $("#modal_delNFe").modal("hide");
});

$("#listaNFe").on("click", ".delNFe", function (ev) {
    ev.preventDefault();
    $("#del_nfeId").attr("disabled", false);
    let data = $("#listaNFe").DataTable().row($(this).parents("tr")).data();
    $("#modal_delNFe").modal();
    $("#del_nfeId").data("nfeId", data.id);
    $("#del_numero_nfe").html(data.numero);
});

$("#del_nfeId").on("click", function (ev) {
    ev.preventDefault();
    $(this).attr("disabled", true);
    let nfeId = $(this).data("nfeId");

    $.post("/deleteNFe", { id: nfeId }, function (data) {
        //console.log(data);
        $("#listaNFe").DataTable().ajax.reload();
        $("#modal_delNFe").modal("hide");
    });
});

$("#listaNFe").on("click", ".loadNFe", function (ev) {
    ev.preventDefault();
    let data = $("#listaNFe").DataTable().row($(this).parents("tr")).data();
    window.location = "/listaNFeItens/" + data.id;
});

$("#btnConfirmar").on("click", function (ev) {
    ev.preventDefault();
    $("#modal_volume").modal("hide");
    loadItens(window.nfe_id);
});

$("#btnReprint").on("click", function (ev) {
    ev.preventDefault();

    let params = {
        nfe_id: window.nfe_id,
    };

    $.post("/reprint", params, function (resp) {
        let zpl = resp.zpl;

        try {
            socket.send(zpl);
            console.log("Impressão enviada som sucesso!");
            //alert('Etiquetas enviadas para impressora \n Arquivo EDI enviado para destinatário');
            $("#modalInfo")
                .modal()
                .find("p")
                .html("Etiqueta enviada para reimpressão!");
            setTimeout(() => {
                //location.reload();
                $("#modalInfo").modal("hide");
            }, 3000);
        } catch (e) {
            console.log(zpl);
            console.error("[Erro] Socket não conectado");
            //alert('Problema ao conectar a impressora. \n Impressão cancelada!');
        }
    });
});

$("#btnTesteImpressao").on("click", function (ev) {
    ev.preventDefault();

    /**
     * ZPL utilizado para teste de impressão
     */
    let zpl =
        "^XA^MMT^LS0 ^FT30,230^A0N,28^FDFornecedor:^FS ^FT180,230^A0N,36^FDFCP INFORMATICA^FS ^FT550,230^A0N,28^FDData:^FS ^FT620,230^A0N,36^FD25/08/2020^FS ^FT30,300^A0N,28^FDItem BR:^FS ^FT149,300^A0N,48^FD0000^FS ^FT453,300^A0N,28^FDCor:^FS ^FT542,300^A0N,48^FD123^FS ^FT30,390^A0N,28^FDQuant/Med.:^FS ^FT280,390^A0N,48^FD1.99^FS ^FT510,390^A0N,48^FDM^FS ^FT140,465^A0N,28^FDTam.:^FS ^FT230,465^A0N,36^FD1.99^FS ^FT390,465^A0N,28^FDLargura:^FS ^FT500,465^A0N,36^FD1.99^FS ^FT30,520^A0N,28^FDMaterial:^FS^FB750,4,0,L,0^FT30,630^A0N,28^FDMATERIAL DE TESTE^FS^FT30,705^A0N,28^FDNF.:^FS^FT140,705^A0N,36^FD9999^FS^FT30,745^A0N,28^FDItem NF.:^FS^FT140,745^A0N,36^FD1^FS^FT421,705^A0N,28^FDO.C.:^FS^FT540,705^A0N,36^FDOC123^FS^FT421,745^A0N,28^FDItem O.C.:^FS^FT540,745^A0N,36^FD1^FS^BY3,3,88^FT30,910^BCN,,Y,N ^FH^FD>;123456789012345678901234^FS ^FT610,960^BQN,2,8 ^FH^FDLA,123456789012345678901234^FS ^RFW,H^FD123456789012345678901234^FS ^PQ1,0,1,Y ^XZ";

    //$("#modalInfo").modal().find('p').html('Cadastro de volumes incompleto!');

    if (status_printer) {
        try {
            socket.send(zpl);
            $("#modalInfo")
                .modal()
                .find("p")
                .html("Teste enviado para a impressora!");
        } catch (e) {
            //console.log(zpl);
            $("#modalInfo")
                .modal()
                .find("p")
                .html("Problema ao fazer impressão!");
            //alert('Problema ao conectar a impressora. \n Impressão cancelada!');
        }
    } else {
        //alert('Problema ao conectar a impressora. \n Impressão cancelada!');
        $("#modalInfo")
            .modal()
            .find("p")
            .html("Problema ao conectar a impressora. Impressão cancelada!");
    }
});

/**
 * Confirma a NF e Processa os Volumes
 * Assim gera o EPC e o Arquivo de EDI
 */
$("#btnConfirmarNFe").on("click", function (ev) {
    ev.preventDefault();

    if (window.totalItemNfe != window.totalVolumesNfe) {
        //alert('Cadastro de volumes incompleto!');
        $("#modalInfo")
            .modal()
            .find("p")
            .html("Cadastro de volumes incompleto!");
        return;
    }

    let confirma = false;
    let params = {
        nfe_id: window.nfe_id,
        sendEDI: 1,
    };

    if (window.tipo_saida) {
        if (window.edi) {
            //confirma = confirm('Você está reenviando o E-mail de EDI! \nNenhum código EPC será alterado. \nConfirmar?')
            $("#modalsendEdi .modal-body").html(
                "<p>Será reenviado o arquivo de EDI para Beirario</p><p>Nenhum código EPC será alterado!</p>"
            );
            $("#modalsendEdi").modal();
        } else {
            //confirma = confirm('Você está confirmando a NFe! \nOs códigos EPC serão gerados e arquivo EDI enviado. \nConfirmar?')
            $("#modalsendEdi .modal-body").html(
                "<p>Você está confirmando a NFe!</p><p>Os códigos EPC serão gerados e arquivo EDI enviado!</p>"
            );
            $("#modalsendEdi").modal();
        }
    } else {
        //alert('Usuário não configurado para gerar EPC e enviar EDI.\n')
        $("#modalInfo")
            .modal()
            .find("p")
            .html("Usuário não configurado para gerar EPC e enviar EDI!");
    }

    /* Implementar ação */
    $("#modalsendEdi .btn-danger").on("click", function (ev) {
        ev.preventDefault();
        //console.log($(this));

        $.post("/confirmarNotaFiscal", params, function (resp) {
            let zpl = resp.zpl;
        })
            .done((data) => {
                location.reload();
            })
            .fail((err) => {
                alert("Erro ao processar! 104");
            });

        $("#modalsendEdi").modal("hide");
    });

    //console.log(printer);
});

function chunk(array, size) {
    const chunked_arr = [];
    for (let i = 0; i < array.length; i++) {
        const last = chunked_arr[chunked_arr.length - 1];
        if (!last || last.length === size) {
            chunked_arr.push([array[i]]);
        } else {
            last.push(array[i]);
        }
    }
    return chunked_arr;
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Imprimir etiquetas
 */
$("#btnPrintLabel").on("click", function (ev) {
    ev.preventDefault();

    if (window.totalItemNfe != window.totalVolumesNfe) {
        //alert('Cadastro de volumes incompleto!');
        $("#modalInfo")
            .modal()
            .find("p")
            .html("Cadastro de volumes incompleto!");
        return;
    }

    if (!window.edi) {
        //alert('Processo ainda não foi confirmado!');
        $("#modalInfo")
            .modal()
            .find("p")
            .html("Processo ainda não foi confirmado!");
        return;
    }

    $("#modalPrintLabel .modal-body").html("<p>Continuar com a impressão?</p>");
    $("#modalPrintLabel").modal();
    //modalPrintLabel

    /*  let confirma = false;
     confirma = confirm('Realizar impressão das Etiquetas?')
     if(!confirma) {
         return ;
     } */

    let params = {
        nfe_id: window.nfe_id,
    };

    $("#modalPrintLabel .btn-danger").on("click", function (ev) {
        ev.preventDefault();

        $.post("/confirmarEtiqueta", params, function (resp) {
            let zpl = resp.zpl;
            // quebra o zpl em 3 arrays
            let zz = chunk(resp.zpl, 20);

            // transforma em 3 strings
            let etiqs = zz.map((ee) => {
                return ee.join();
            });

            //console.log(ver);

            if (resp.tipo_saida) {
                if (status_printer) {
                    etiqs.map((etiq) => {
                        try {
                            socket.send(etiq);
                            //console.log('Impressão enviada som sucesso!')
                            //alert('Etiquetas enviadas para impressora \n Arquivo EDI enviado para destinatário');
                            $("#modalPrintLabel .modal-body p").remove();
                            $("#modalPrintLabel .modal-body").append(
                                "<p>Etiquetas enviadas para impressora!</p>"
                            );
                            $("#modalPrintLabel .btn-danger").attr(
                                "disabled",
                                true
                            );
                        } catch (e) {
                            console.error("[Erro] Socket não conectado");
                            //alert('Problema ao conectar a impressora. \nImpressão cancelada!');
                            $("#modalPrintLabel .modal-body p").remove();
                            $("#modalPrintLabel .modal-body").append(
                                "<p>Problema ao conectar a impressora. <strong>Impressão cancelada!</strong></p>"
                            );
                        }
                    });
                } else {
                    //alert('Problema ao conectar a impressora. \nImpressão cancelada!');
                    $("#modalPrintLabel .modal-body p").remove();
                    $("#modalPrintLabel .modal-body").append(
                        "<p><strong> Impressora não conectada! </strong></p>"
                    );
                    if (!window.edi) {
                        location.reload();
                    }
                }

                //
            } else {
                // Gera PDF
                if (resp.tipo_saida == 0) {
                    etiqs.map((el) => {
                        $.ajax({
                            type: "POST",
                            async: false,
                            url: "/viewLabel",
                            data: { zpl: el },
                            success: function (data) {
                                //console.log(data);
                                window.open(data);
                            },
                        }).fail(function (error) {
                            //alert('Erro ao processar!');
                            $("#modalPrintLabel .modal-body p").remove();
                            $("#modalPrintLabel .modal-body").append(
                                "<p><strong> Erro ao processar! </strong></p>"
                            );
                            console.error(error);
                        });
                    });
                } else {
                    //alert('Nenhuma ação');
                    $("#modalPrintLabel .modal-body p").remove();
                    $("#modalPrintLabel .modal-body").append(
                        "<p><strong> Nenhuma ação! </strong></p>"
                    );
                }
            }
        }).fail((err) => {
            //console.log(err);
            //alert(`Erro ao processar: ${err.responseJSON.msg}`);
            $("#modalPrintLabel .modal-body p").remove();
            $("#modalPrintLabel .modal-body").append(
                `<p>Erro ao processar: ${err.responseJSON.msg}<p>`
            );
        });

        setTimeout(() => {
            //location.reload();
            $("#modalPrintLabel").modal("hide");
        }, 3500);
    });
});

/**
 * Submit fomulário de cadastro de Emitente
 */
$("#formEmitente").submit(function (ev) {
    ev.preventDefault();
    $(".cnpj").unmask();

    var form = $(this);
    var url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            //console.log(data);
            if ($("input[name=id]").val() === undefined) {
                alert("Novo emitente cadastrado com sucesso!");
            } else {
                alert("Emitente atualizado com sucesso!");
            }

            window.location = "/emitentes";
        },
        error: function (error) {
            console.error(error.responseJSON.message);
        },
    });

    $(".cnpj").mask("00.000.000/0000-00", { reverse: false });
});

/**
 * Submit formulário de cadastro de Emitente
 */
$("#formUser").submit(function (ev) {
    ev.preventDefault();

    if ($("input[name=id]").val() === undefined) {
        let conf = confirm("Cadastrar novo usuário?");
        if (!conf) {
            return;
        }
    } else {
        let conf = confirm("Confirmar alterações no usuário?");
        if (!conf) {
            return;
        }
    }

    var form = $(this);
    var url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            //console.log(data);
            //alert('Usuário Cadastrado com sucesso!');
            window.location = "/users";
        },
        error: function (error) {
            alert("Erro ao cadastrar: " + error.responseJSON.message);
            //console.error(error.responseJSON.message);
        },
    });
});

function load_emitentes() {
    $.ajax({
        url: "/emitentes/all",
        type: "GET",
        success: (resp) => {
            $("#table_emitentes").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "razao_social" },
                    { data: "nome_fantasia" },
                    { data: "api_version" },
                    {
                        data: null,
                        render: function (data, type, row) {
                            if (type === "display") {
                                return data.cnpj.replace(
                                    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                                    "$1.$2.$3/$4-$5"
                                );
                            }
                            return data.cnpj;
                        },
                    },
                    {
                        data: null,
                        className: "text-center",
                        render: function (data, type, row, meta) {
                            if (type === "display") {
                                if (data.status == 0) {
                                    //return 'A enviar'
                                    return '<div class="text-center"><span class="badge badge-danger">Inativa</label></div>';
                                } else {
                                    //return 'Enviado'
                                    return '<div class="text-center"><span class="badge badge-success">Ativa</label></div>';
                                }
                            }
                        },
                        defaultContent: "",
                    },
                    {
                        data: null,
                        defaultContent:
                            '<button type="button" class="editEmitente btn btn-secondary btn-sm" style="color:#fff"><i class="far fa-edit"></i></button>',
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_emitentes").on("click", ".editEmitente", function (ev) {
        ev.preventDefault();
        let data = $("#table_emitentes")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/emitente/" + data.id;
    });
}

function load_users() {
    let button =
        '<button type="button" class="editUser btn btn-info btn-sm" style="color:#fff"><i class="fas fa-user-edit"></i></button>';
    button +=
        '<button type="button" class="editUser btn btn-danger btn-sm ml-2" style="color:#fff"><i class="fas fa-user-times"></i></button>';

    $.ajax({
        url: "/users/all",
        type: "GET",
        success: (resp) => {
            $("#table_users").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "name" },
                    { data: "email" },
                    {
                        data: null,
                        className: "text-center",
                        render: function (data, type, row, meta) {
                            if (type === "display") {
                                if (data.status == 0) {
                                    //return 'A enviar'
                                    return '<div class="text-center"><span class="badge badge-danger">Inativa</label></div>';
                                } else {
                                    //return 'Enviado'
                                    return '<div class="text-center"><span class="badge badge-success">Ativa</label></div>';
                                }
                            }
                        },
                        defaultContent: "",
                    },
                    {
                        data: null,
                        className: "text-center",
                        defaultContent: button,
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_users").on("click", ".btn-info", function (ev) {
        ev.preventDefault();
        let data = $("#table_users")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/user/" + data.id;
    });

    $("#table_users").on("click", ".btn-danger", function (ev) {
        ev.preventDefault();
        let data = $("#table_users")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        $.post("/user/remove", { id: data.id })
            .done((resp) => {
                console.log(resp);
            })
            .fail((erro) => {
                console.log(JSON.parse(erro.responseText).message);
            });
    });
}

$("#addEmitente").on("click", function (ev) {
    ev.preventDefault();
    let emitente = $("#listEmitentes").val();
    //console.log(emitente);
});

$("#cfop").on("keypress", function (ev) {
    var tecla = window.event ? ev.keyCode : ev.which;
    var texto = $(this).val();

    if (tecla == 8 || tecla == 0) return true;
    if ((tecla != 44 && tecla != 46 && tecla < 48) || tecla > 57) return false;
    if (tecla == 46) {
        return false;
    }
});

function load_etiquetas() {
    let button =
        '<button type="button" class="editUser btn btn-info btn-sm" style="color:#fff"><i class="fas fa-edit"></i></button>';
    button +=
        '<button type="button" class="editUser btn btn-danger btn-sm ml-2" style="color:#fff"><i class="fas fa-times"></i></button>';

    $.ajax({
        url: "/etiquetas/list",
        type: "GET",
        success: (resp) => {
            $("#table_etiqueta").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "id" },
                    { data: "name" },
                    {
                        data: null,
                        className: "text-right",
                        defaultContent: button,
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_etiqueta").on("click", ".btn-info", function (ev) {
        ev.preventDefault();
        let data = $("#table_etiqueta")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/etiquetas/edit/" + data.id;
    });

    $("#table_etiqueta").on("click", ".btn-danger", function (ev) {
        ev.preventDefault();
        let data = $("#table_etiqueta")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        $.post("/etiquetas/remove", { id: data.id })
            .done((resp) => {
                console.log(resp);
                $("#table_etiqueta").DataTable().ajax.reload();
            })
            .fail((erro) => {
                alert(JSON.parse(erro.responseText).message);
                //console.log(JSON.parse(erro.responseText).message);
            });
    });
}

$(function () {
    //
    if (window.nfe_id !== undefined) {
        loadItens(window.nfe_id);
    }

    //gerarIPC
    $("#gerarIPC").on("click", function () {
        $("#btnConfirmarNFe").prop("disabled", false);
    });

    $("body").keydown(function (e) {
        //e.preventDefault();
        if (e.keyCode == 120) {
            $("#addVolume").trigger("click");
        }
        //120 - e.keyCode
    });

    $(".cnpj").mask("00.000.000/0000-00", { reverse: false });

    //$("#table_emitentes").DataTable({});
    load_emitentes();
    load_users();
    load_nfe();
    load_etiquetas();

    if (location.pathname == "/listagemGeral") {
        //console.log('aqui')
        listagemGeral();
    }

    $("#listEmitentes").select2({
        placeholder: "Digite a empresa",
        language: "pt-BR",
        width: "resolve",
        ajax: {
            url: "/emitentes/all",
            dataType: "json",
            quietMillis: 150,
            minimumInputLength: 4,
            multiple: false,
            data: function (term, page) {
                //term.state = $('#select_state :selected').text();
                return term;
            },
            processResults: function (data, page) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            text: item.razao_social,
                            id: item.id,
                        };
                    }),
                };
            },
        },
    });

    $("#btnBuscar").on("click", function (ev) {
        ev.preventDefault();
        listagemGeral();
    });
});

$("#navbarSupportedContent .text-danger").on("click", function (ev) {
    ev.preventDefault();
    let ok = confirm("Confirma limpar o banco de dados?");
    if (ok) {
        $.get("/limpabase", function (resp) {
            // console.log(resp);
            alert("Base limpa com sucesso!");
            location.reload();
        });
    }
});

$("#trocaEmitente").on("click", function (ev) {
    ev.preventDefault();
    let link = $(this).attr("href");
    $("#modal_emitente").modal();
    //console.log(link);
});

$("#listaModalEmitentes .emitente").on("click", function (ev) {
    ev.preventDefault();
    let emitente_id = $(this).data("id");
    $.post("/setEmitente", { emitente_id }, function (resp) {
        //alert(resp.message);
        //window.location.reload();
        location.href = "/notasfiscais";
    });
});

$("#btnListaVolumes").on("click", function (ev) {
    ev.preventDefault();
    let lista = $("#listaVolumes");
    let nfe_id = window.nfe_id;
    //$("#pdfModal").html(`<object type="application/pdf" data="/getVolumeList/${nfe_id}"  width="100%" height="500px" VIEWASTEXT></object>`);
    window.open(`/getVolumeList/${nfe_id}`);
    //$.get(`/getVolumeList/${nfe_id}`)
    /* axios.get(`/getVolumeList/${nfe_id}`)
    .then(resp => {
        console.log(resp)
        $("#pdfModal").html(resp.data);
    }).catch(erro => {
        console.log(erro);
    }) */

    //$('#modal_pdf').modal();

    /* $.get(`/getVolumeList/${nfe_id}`, (resp) => {

    })
    .fail(error => {
        console.error(error)
    }); */
});

$("#editDescricao").on("click", function (ev) {
    ev.preventDefault();
    let nfe_id = window.nfe_id;
    let item_id = parseInt($("#nfe_item_id").val());

    //console.debug({ nfe_id, item_id});
    let input = $("#nfe_item_desc").val();

    /* let confirma = confirm('Atualizar descrição do Item?');
    if(!confirma) {
        return;
    } */

    $.post(`/editNfeDesc/${item_id}`, { desc: input }, function (resp) {
        //console.log(resp);
        $("#infoDescricao").show("slow");
        setTimeout(() => {
            $("#infoDescricao").hide("slow");
        }, 3000);

        loadItens(window.nfe_id);
    });
});

$("#editQuantidade").on("click", function (ev) {
    ev.preventDefault();
    let nfe_id = window.nfe_id;
    let item_id = parseInt($("#nfe_item_id").val());

    //console.debug({ nfe_id, item_id});
    let volume_quantidade = parseFloat(
        $("#nfe_quantidade").val().replace(/,/g, ".")
    );

    if (isNaN(volume_quantidade)) {
        //alert('Quantidade inválida');
        $("#modalInfo").modal().find("p").html("Quantidade inválida");
        return;
    }

    $.post(
        `/editNfeQtde/${item_id}`,
        { qtde: volume_quantidade },
        function (resp) {
            //console.log(resp);
            $("#infoQuantidade").show("slow");
            setTimeout(() => {
                $("#infoQuantidade").hide("slow");
            }, 3000);

            loadItens(window.nfe_id);
        }
    );
});

$("#saveObs").on("click", function (ev) {
    ev.preventDefault();
    let nfe_id = window.nfe_id;
    let item_id = parseInt($("#nfe_item_id").val());

    //console.debug({ nfe_id, item_id});
    let input = $("#nfe_item_obs").val();

    /* let confirma = confirm('Atualizar descrição do Item?');
    if(!confirma) {
        return;
    } */

    $.post(`/obsNfeDesc/${item_id}`, { obs: input }, function (resp) {
        //console.log(resp);
        $("#infoObs").show("slow");
        setTimeout(() => {
            $("#infoObs").hide("slow");
        }, 3000);

        loadItens(window.nfe_id);
    });
});

$("#saveUnidade").on("click", function (ev) {
    ev.preventDefault();
    let nfe_id = window.nfe_id;
    let item_id = parseInt($("#nfe_item_id").val());

    // console.log("saveUnidade.click");
    let input = $("#nfe_unidade").val();

    $.post(`/UnidadeNfe/${item_id}`, { unidade: input }, function (resp) {
        //console.log(resp);
        $("#infoUnidade").show("slow");
        setTimeout(() => {
            $("#infoUnidade").hide("slow");
        }, 3000);

        loadItens(window.nfe_id);
    });
});

///
function listagemGeral() {
    let dados = new Promise((resolve, reject) => {
        $.post(
            "/getListagemGeral",
            {
                data_ini:
                    $("#data_ini").val() == ""
                        ? "2019-01-01"
                        : $("#data_ini").val(),
                data_fim:
                    $("#data_fim").val() == ""
                        ? "2030-01-01"
                        : $("#data_fim").val(),
            },
            (resp) => {
                resolve(resp);
            }
        ).fail(() => reject("Erro ao buscar dados"));
    });

    dados
        .then((result) => {
            $("#listaEmitentes").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                //order: [[ 1, "desc" ]],
                searching: false,
                data: result.data,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //pageLength: 10,
                info: false,
                columns: [
                    { data: "cnpj" },
                    { data: "razao_social" },
                    { data: "notas" },
                    { data: "volumes" },
                ],
            });

            $("#totalDocs").text(result.totalDocs);
            $("#totalEpcs").text(result.totalEpcs);
        })
        .catch((erro) => {
            console.log(erro);
        });
}

$(document).ready(function () {
    // Handler para o botão "Entendi"
    $("#btnFecharAviso").on("click", function () {
        $("#modalAviso").modal("hide");
    });

    // Handler para o botão "X" (close)
    $("#btnCloseAviso").on("click", function () {
        $("#modalAviso").modal("hide");
    });

    // Previne que o modal principal seja fechado
    $("#modalAviso").on("hidden.bs.modal", function (e) {
        if ($("#modal_volume").hasClass("show")) {
            $("body").addClass("modal-open");
        }
    });
});

// Abrir modal de edição ao clicar no botão Editar
$("#listaVolume").on("click", ".btnEditarVolume", function (ev) {
    ev.preventDefault();
    
    // Captura os dados da linha exata onde o botão foi clicado
    let data = $("#listaVolume").DataTable().row($(this).parents("tr")).data();
    
    // Preenche os inputs do novo modal com os dados da linha
    // IMPORTANTE: precisamos garantir que o 'id' (ou código identificador) do volume exista aqui
    $("#edit_vol_id").val(data.id); 
    $("#edit_vol_itembr").val(data.item_br);
    $("#edit_vol_cor").val(data.cor);
    $("#edit_vol_largura").val(data.largura);
    $("#edit_vol_tamanho").val(data.tamanho);

    // Exibe o modal
    $("#modalEditarVolume").modal("show");
});

// Salvar as edições do volume
$("#btnSalvarEdicaoVolume").click(function () {
    let btn = $(this);
    let textoOriginal = btn.html();
    
    // Captura os dados preenchidos no modal
    let dados = {
        id: $("#edit_vol_id").val(),
        item_br: $("#edit_vol_itembr").val(),
        cor: $("#edit_vol_cor").val(),
        largura: $("#edit_vol_largura").val(),
        tamanho: $("#edit_vol_tamanho").val()
    };

    // Altera o botão para mostrar que está carregando
    btn.html('<i class="fas fa-spinner fa-spin"></i> Salvando...').prop('disabled', true);

    // Envia os dados para o Laravel
    $.ajax({
        url: '/editVolume',
        type: 'POST',
        data: dados,
        success: function (response) {
            // Fecha o modal de edição
            $("#modalEditarVolume").modal("hide");
            
            // Recarrega a tabela de volumes para mostrar os dados novos
            $('#listaVolume').DataTable().ajax.reload(null, false);
            
            // Restaura o botão
            btn.html(textoOriginal).prop('disabled', false);
        },
        error: function (xhr) {
            alert("Ocorreu um erro ao tentar salvar. Verifique o console.");
            console.log(xhr.responseText);
            btn.html(textoOriginal).prop('disabled', false);
        }
    });
});
